import React from "react"
import { RellaxWrapper as Rellax } from "react-rellax-wrapper"

import * as s from "./Timeline.module.scss"

import MapPin from "@assets/icons/mapPinSimple.inline.svg"

export const Timeline = ({ data }) => {
  const { title, subtitle, titleImage, entries } = data

  return (
    <div className={s.wrapper}>
      <div className={s.intro}>
        {titleImage && (
          <img
            className={s.logo}
            src={titleImage.sourceUrl}
            alt={titleImage.altText}
          />
        )}

        <h2>{title}</h2>
        <h3>{subtitle}</h3>
      </div>

      <div className={s.timelineEntries}>
        {entries.map((entry, i) => {
          return (
            <div
              key={i}
              className={`${s.entry} ${
                entry.secondaryImage ? s.hasSecondary : ""
              }`}
            >
              <div className={s.paddingWrapper}>
                <Rellax
                  center={true}
                  xs={-0.5}
                  mobile={-0.5}
                  tablet={-2}
                  desktop={-2}
                  className={s.year}
                >
                  {entry.year}
                </Rellax>

                <Rellax
                  center={true}
                  xs={0.5}
                  mobile={0.5}
                  tablet={2}
                  desktop={2}
                  className={s.content}
                >
                  <div className={s.tag}>
                    <MapPin className={s.icon} />
                    {entry.tag}
                  </div>

                  <div className={s.text}>{entry.textContent}</div>
                </Rellax>
                <div className={s.image}>
                  <img
                    src={entry.mainImage.sourceUrl}
                    alt=""
                    className={s.primary}
                  />

                  {entry.secondaryImage && (
                    <img
                      src={entry.secondaryImage.sourceUrl}
                      alt=""
                      className={s.secondary}
                    />
                  )}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
